import { render } from "./FsaClaimsProcess.vue?vue&type=template&id=5fc69fbc&scoped=true"
import script from "./FsaClaimsProcess.vue?vue&type=script&lang=js"
export * from "./FsaClaimsProcess.vue?vue&type=script&lang=js"

import "./FsaClaimsProcess.vue?vue&type=style&index=0&id=5fc69fbc&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc69fbc"]])

export default __exports__